module.exports = __webpack_public_path__ + "img/sv78.dd4be0a7.svg";